var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_rounded--common _flexcol _pos-r _gap-h _ov-h" },
    _vm._l(_vm.items, function (item) {
      return _c(
        "div",
        {
          key: item.iconName,
          staticClass: "_pa-3 _bgc--light _flex _gap-2 _ai-c",
        },
        [
          _c(
            "div",
            [
              _c("base-icon", {
                staticClass: "_tc--accent",
                attrs: {
                  name: item.iconName,
                  size: "2x",
                  "is-fixed-width": "",
                  "has-base-class": "",
                  "icon-namespace": item.iconNamespace,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _vm._v("\n            " + _vm._s(item.text) + "\n            "),
            item.moreUrl
              ? _c(
                  "a",
                  { staticClass: "_tc--accent", attrs: { href: item.moreUrl } },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(item.moreLabel) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }